import script from "./mainIndex.vue?vue&type=script&lang=ts&setup=true"
export * from "./mainIndex.vue?vue&type=script&lang=ts&setup=true"

import "./mainIndex.vue?vue&type=style&index=0&id=1161be45&lang=scss&scoped=true"

import exportComponent from "/opt/jenkins/data/workspace/PRD.standard_checktarget_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1161be45"]])

export default __exports__